export default "__VITE_ASSET__K_1JolJU__"